import $ from 'jquery' // jQuery
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const toggleScroll = document.querySelector('body')
const modalsData = document.getElementsByClassName('js_modal')
const modalArray = Array.from(modalsData).entries()
const modals = document.getElementsByClassName('modal')
const closeButtons = document.getElementsByClassName('btn-close')
const closeModal = document.getElementsByClassName('videoModal')
const jsModalVideo = document.getElementsByClassName('jsModal-Video')
const modalVideo = document.getElementsByClassName('modal-video')

for (let [index, item] of modalArray) {
  const toggleModal = () => {
    modals[index].classList.toggle('show-modal')
    toggleScroll.classList.toggle('no-scroll')
    if (modalVideo[index] !== undefined) {
      modalVideo[index].pause()
      modalVideo[index].currentTime = 0
    }
  }
  item.addEventListener('click', toggleModal)
  if (closeModal[index] !== undefined) {
    console.log('closeModal[index]' + closeModal[index])
    closeModal[index].addEventListener('click', toggleModal)
  } else {
    closeButtons[index].addEventListener('click', toggleModal)
  }

  // ビデオにクリックするのは無視する
  if (jsModalVideo[index] !== undefined) {
    jsModalVideo[index].addEventListener('click', function (e) {
      e.stopPropagation()
    })
  }
}

// Load More
var loadMore = (number = 4) => {
  $('.js__Item:hidden')
    .slice(0, number / 2)
    .slideDown()
  if ($('.js__Item:hidden').length == 0) {
    $('.js_btnMore').hide()
    $('.js_btnLess').fadeIn('slow')
  }
  return false
}
var loadLess = (number = 4) => {
  $('.js__Item:not(:lt(' + number + '))').fadeOut()
  $('.js_btnMore').fadeIn('slow')
  $('.js_btnLess').hide()
}

$(function () {
  let single_num = 6
  let archive_num = 4

  $('.sInterviewOthers__Item').slice(0, single_num).show()
  $('.js_btnLess').hide()
  $('.js_btnMore').on('click', function () {
    loadMore(single_num)
  })

  $('.js_btnLess').on('click', function (e) {
    loadLess(single_num)
  })

  $('.arcInterviewGraduates__Item').slice(0, archive_num).show()
  $('.js_btnMore2').on('click', function () {
    loadMore(archive_num)
  })

  $('.js_btnLess2').on('click', function (e) {
    loadLess(archive_num)
  })

  //社員インタビュー フィルター
  var $filters = $('.filter [data-department]'),
    $filters2 = $('.filter [data-branch]')
  $($filters).on('click', function (e) {
    e.preventDefault()
    var $this = $(this)
    $filters.removeClass('active')
    $this.addClass('active')

    var $item = $(this).attr('data-department')

    if ($item == 'all') {
      $('.js-filterable').removeClass('hide1')
    } else {
      $('.js-filterable').addClass('hide1')
      $('.js-filterable[data-department=' + $item + ']').removeClass('hide1')
    }
  })
  $($filters2).on('click', function (e) {
    e.preventDefault()
    var $this = $(this)
    $filters2.removeClass('active')
    $this.addClass('active')

    var $item = $(this).attr('data-branch')

    if ($item == 'all') {
      $('.js-filterable').removeClass('hide2')
    } else {
      $('.js-filterable').addClass('hide2')
      $('.js-filterable[data-branch=' + $item + ']').removeClass('hide2')
    }
  })
})

var searchFilter = (e) => {
  let curElm = $(e).find(':selected').val()

  if (curElm == 'all') {
    $('.js-filterable').removeClass('hide1')
  } else {
    $('.js-filterable').addClass('hide1')
    $('.js-filterable[data-department=' + curElm + ']').removeClass('hide1')
  }
}

$(function () {
  $('.js_dropdown').on('change', function () {
    searchFilter(this)
  })
})

/*
 ######   ######          ##    ##    ###    ##     ##
##       ##               ####  ##  ##   ##  ##     ##
 ######  ##       ####### ## ## ## ##     ## ##     ##
      ## ##               ##  #### #########  ##   ##
 ######   ######          ##    ## ##     ##    ###

ターゲットが走査線に入ったら連動する要素にクラスを当てる
Intersection Observer APIを使用

<a href="#hoge" class="js-scrollNav js-scrollNav--hoge"></a>
<section id="hoge" class="js-scrollNav-trigger" data-nav-target="hoge">
  section#hogeが画面に入ったらjs-scrollNav--hogeにクラスを当てる
</section>
*/

if (document.getElementsByClassName('js-scrollNav')[0]) {
  scrollNav()
}
function scrollNav() {
  const navItems = document.getElementsByClassName('js-scrollNav')
  const intObsOption = {
    rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(scrollNavCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-scrollNav-trigger')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function scrollNavCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触アイテムを発見
      if (entry.isIntersecting) {
        // 全ての.activeを外す
        for (let index = 0; index < navItems.length; index++) {
          navItems[index].classList.remove('current')
        }
        const entryItem = entry.target
        const target = entryItem.dataset.navTarget // 制御対象名を取得

        // 対象アイテムをアクティブにする
        const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
        for (let index = 0; index < targetItems.length; index++) {
          const targetItem = targetItems[index]
          targetItem.classList.add('current')
        }
        break // 以降の判定は飛ばす
      }
    }
  }
}

function hasQueryParams(url) {
  return url.indexOf('?') !== -1
}

function scrollToElement(ele) {
  if (hasQueryParams(window.location.href) === true) {
    $('html, body').animate({ scrollTop: $(ele).offset().top - 40 }, 400)
  }
}
if (document.getElementById('shortVideo')) {
  scrollToElement($('#shortVideo'))
}

if (document.getElementsByClassName('pBunka')[0]) {
  pageCulture()
}

function pageCulture() {
  var o = 'expo.out'
  let mm = gsap.matchMedia()
  let scaleFrom
  let txtShowStart
  let txtShowEnd
  let MVStart
  let MVEnd
  let txtFadeUp
  let scaleObj

  mm.add('(max-width: 767px)', () => {
    scaleFrom = '.9'
    txtShowStart = '10'
    txtShowEnd = '300'
    MVStart = '20'
    MVEnd = '500'
    txtFadeUp = '0'
    scaleObj = '-80'
  })

  mm.add('(min-width: 768px)', () => {
    scaleFrom = '.74'
    txtShowStart = '200'
    txtShowEnd = '600'
    MVStart = '-50'
    MVEnd = '600'
    txtFadeUp = '0'
    scaleObj = '-180'
  })

  gsap.fromTo(
    '.js_blur',
    {
      opacity: '1',
    },
    {
      opacity: txtFadeUp,
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_blur',
        start: '120', // 開始位置
        end: '600', // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_cultureMV',
    {
      y: '0',
      scale: scaleFrom,
    },
    {
      y: scaleObj,
      scale: '1',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_cultureMV',
        start: MVStart,
        end: MVEnd,
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
  gsap.fromTo(
    '.js_cultureTxt',
    {
      opacity: '0',
    },
    {
      opacity: '1',
      yPercent: '-80',
      duration: 1,
      ease: o,
      scrollTrigger: {
        trigger: '.js_cultureTxt',
        start: txtShowStart, // 開始位置
        end: txtShowEnd, // 終了位置
        scrub: 1,
        markers: false,
      },
    },
    '-='.concat(2)
  )
}

if (document.getElementsByClassName('pFuture')[0]) {
  const targetElm = document.querySelector('.pFutureHistoryList')

  function toggleClassOnScroll() {
    const threshold = 500
    let screenPos = targetElm.getBoundingClientRect()
    let targetStatistic = document.querySelector('.statistic')

    const targetSpecial = document.querySelector('#target-11')
    const rectTarget = targetSpecial.getBoundingClientRect()

    if (screenPos.top < threshold && rectTarget.top > 300) {
      targetElm.classList.add('isFade')
      targetStatistic.classList.add('isShow')
    } else {
      targetElm.classList.remove('isFade')
      targetStatistic.classList.remove('isShow')
    }
  }

  window.addEventListener('scroll', toggleClassOnScroll)
}
